module.exports = __webpack_public_path__ + "img/ic-nor-filter.c0ef6d7f.svg";